import { TrendingUp, TrendingDown, Activity, Zap, Sun, Droplet } from 'lucide-react';

export function StatsBoard() {
  const stats = [
    {
      category: 'Power Generation',
      icon: Zap,
      metrics: [
        { label: 'Installed Capacity', value: '14 GW', trend: 'neutral' },
        { label: 'Average Available', value: '4.3 GW', trend: 'up', change: '+3.8%' },
        { label: 'Peak Demand', value: '30 GW', trend: 'up' },
      ],
      color: 'text-[#006b40]',
      bgColor: 'bg-[#E8F5E9]',
    },
    {
      category: 'Renewable Energy',
      icon: Sun,
      metrics: [
        { label: 'Current Capacity', value: '3.5 GW', trend: 'up', change: '+11.8%' },
        { label: '2029 Target', value: '5.01 GW', trend: 'up' },
        { label: 'Solar Growth', value: '9.88% CAGR', trend: 'up' },
      ],
      color: 'text-[#8a5a00]',
      bgColor: 'bg-yellow-50',
    },
    {
      category: 'Oil & Refining',
      icon: Droplet,
      metrics: [
        { label: 'Dangote Capacity', value: '700k bpd', trend: 'up' },
        { label: 'Current Utilization', value: '85%', trend: 'up', change: '+20%' },
        { label: 'Total Refineries', value: '6 Operational', trend: 'up' },
      ],
      color: 'text-black',
      bgColor: 'bg-gray-50',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Energy Sector Overview
          </h2>
          <p className="text-lg text-gray-600">
            Key statistics and metrics from Nigeria's energy landscape
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Last updated: June 2026
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className={`${stat.bgColor} rounded-xl p-6 border-2 border-gray-200`}>
                <div className="flex items-center gap-3 mb-6">
                  <div className={`w-10 h-10 ${stat.color} bg-white rounded-lg flex items-center justify-center`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className={`text-xl font-bold ${stat.color}`}>
                    {stat.category}
                  </h3>
                </div>

                <div className="space-y-4">
                  {stat.metrics.map((metric, mIndex) => (
                     <div key={mIndex} className="bg-white rounded-lg p-4">
                      <div className="flex justify-between items-start mb-1">
                        <span className="text-sm text-gray-600">{metric.label}</span>
                        {metric.trend === 'up' && (
                          <TrendingUp className="w-4 h-4 text-green-500" />
                        )}
                        {metric.trend === 'down' && (
                          <TrendingDown className="w-4 h-4 text-red-500" />
                        )}
                        {metric.trend === 'neutral' && (
                          <Activity className="w-4 h-4 text-gray-400" />
                        )}
                      </div>
                      <div className="flex justify-between items-end">
                        <span className="text-2xl font-bold text-gray-900">{metric.value}</span>
                        {metric.change && (
                          <span className={`text-sm font-medium ${
                            metric.trend === 'up' ? 'text-[#006b2d]' : 'text-red-600'
                          }`}>
                            {metric.change}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Key Facts */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-[#E8F5E9] rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-[#006b40] mb-1">232M</div>
            <div className="text-sm text-gray-600">Population</div>
          </div>
          <div className="bg-[#E8F5E9] rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-[#006b40] mb-1">45%</div>
            <div className="text-sm text-gray-600">Grid Access</div>
          </div>
          <div className="bg-[#E8F5E9] rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-[#006b40] mb-1">~4 hrs</div>
            <div className="text-sm text-gray-600">Avg Daily Power</div>
          </div>
          <div className="bg-[#E8F5E9] rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-[#006b40] mb-1">$14B</div>
            <div className="text-sm text-gray-600">Annual Generator Spend</div>
          </div>
        </div>
      </div>
    </section>
  );
}
